<template>
    <div class="popup-layout" @click="close" v-if="visible">
        <div class="popup-content"><slot /></div>
    </div>
</template>

<script>
export default {
    name: 'PopUp',
    props: ['show'],
    computed: {
        visible(){
            return this.show;
        }
    },
    methods: {
        close(e){
            if(e.target.classList.contains('popup-layout'))
                this.$emit('close');
        }
    }
}
</script>

<style>
.popup-layout{
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(27, 27, 27, 0.2);
    position: absolute;
}
.popup-content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 40px);
    max-width: 350px;
}
</style>